import ScrollUpBtn from "../components/ScrollUpBtn"
import AdBanner from "../components/home/AdBanner"
import CatByPics from "../components/home/CatByPics"
import Showcase from "../components/home/Showcase"
import TopAppliances from "../components/home/TopAppliances"
import TopFashion from "../components/home/TopFashion"
import TopPhones from "../components/home/TopPhones"
import TopSales from "../components/home/TopSales"
import Top from "../components/home/top"
import AdImg from '../assets/ad3.webp'
import NewArrival from "../components/home/NewArrival"
import ForYou from "../components/home/ForYou"
import Subscribe from "../components/home/Subscribe"
import Footer from "../components/home/Footer"

const Home = () => {

    return (
        <div className=" relative w-full min-h-screen">
            <Top />
            <Showcase />
            <CatByPics />
            <TopSales />
            <AdBanner adImg={AdImg} link={'#/'} />
            <TopFashion />
            <TopAppliances />
            <TopPhones />
            <AdBanner adImg={AdImg} link={'#/'} />
            <NewArrival />
            <ForYou />
            <Subscribe />
            <Footer />

            <ScrollUpBtn />
        </div>
    )
}

export default Home